import {isNil} from 'ramda';

/**
 * Body styles considered interchangeable with one another (compact class).
 * A user looking for one of these is typically also interested in the others.
 */
export const SIMILAR_BODY_STYLES = [
  'CARSTYLE_HATCHBACK',
  'CARSTYLE_LIFTBACK',
  'CARSTYLE_SEDANS_SALOONS',
  'CARSTYLE_COMPACT',
];

/**
 * Returns the list of body styles that should be treated the same as the given one.
 * For compact-class bodies, returns the whole equivalence group; otherwise returns
 * just the input value (or [] if no body style is provided).
 */
export const getSimilarBodyStyles = (bodyStyle: string | undefined): string[] => {
  if (isNil(bodyStyle)) {
    return [];
  }
  return SIMILAR_BODY_STYLES.includes(bodyStyle) ? SIMILAR_BODY_STYLES : [bodyStyle];
};
